import React from "react";
import { useParams } from 'react-router-dom';
import CadastrarOrcamentoPrestador from "./CadastrarOrcamentoPrestador";


const EditarOrcamentoPrestador = () => {
    const { id } = useParams();

    return <CadastrarOrcamentoPrestador orcamentoId={id} />;
};

export default EditarOrcamentoPrestador;
